import { useRef, useEffect } from "react";
// import { CellProps } from 'react-table';

// interface RowCheckboxProps<T extends object> extends CellProps<T> {}

/*
function RowCheckbox<T extends object>({ row }: RowCheckboxProps<T>)
*/

function RowCheckbox({ row }) {
  const { indeterminate, ...rest } = row.getToggleRowSelectedProps();

  const defaultRef = useRef(null);

  useEffect(() => {
    if (defaultRef.current) {
      defaultRef.current.indeterminate = !!indeterminate;
    }
  }, [defaultRef, indeterminate]);

  return (
    <div className="tw-flex tw-justify-center">
      <input
        id={`_${row.id}_checkbox`}
        type="checkbox"
        className="tw-w-4 tw-h-4"
        {...rest}
      />
    </div>
  );
}

export default RowCheckbox;
